var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',{attrs:{"name":"LayoutDefault"}},[_c('div',{staticClass:"Contact"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"contents"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"alert alert-success col-lg-12"},[_vm._v("\n            আপনার অর্ডারটি সফলভাবে সম্পন্ন হয়েছে । ধন্যবাদ\n          ")])])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }